<template>
    <div class="container-fluid">
        <div v-if="$can('orders create')" class="row justify-content-center">
            <div class="default-page-width">
                <div class="card card-default">
                    <div class="card-header">{{$t('orders.'+mode+'.title')}}</div>
                    <div class="card-body">
                        <form-order
                            :mode="'create'"
                            :context="context"
                            :presetobjectid=rmsobjectid
                            :presetcustomerid="customerid"
                        ></form-order>
                    </div>
                </div>
            </div>
        </div>
        <h1 v-if="!$can('orders create')">{{$t('access-denied')}}</h1>
    </div>
</template>

<script>

export default {
    name: "order-create",
    props: {
        user: [String, Number],
        mode: {
            type: String,
            default: 'create'
        },
        context:[String],
        rmsobjectid:[Number],
        customerid:[Number]
    },
    data: function () {
        return {
            presetRmsObjectId: undefined
        }
    },
    mounted() {
        console.log("order-create init... ", this.orderid, this.mode, this.context);
        /*if(this.presetdata){
            if(this.presetdata.hasOwnProperty("rmsobjectId")){
                this.presetRmsObjectId = this.presetdata.rmsobjectId;
            }
        }*/
    },

}
</script>

<style scoped>

</style>
